// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user_info[data-v-0845550e]{display:flex;align-items:center;justify-content:center;width:182px;height:61px;background:#fff;border-radius:8px}.avatar[data-v-0845550e]{width:32px;height:32px;border-radius:50%}.text_container[data-v-0845550e]{display:flex;flex-direction:column;justify-content:space-between;margin-left:8px;font-size:12px;color:#333}.text_container .name[data-v-0845550e]{margin-bottom:6px;font-weight:700}", ""]);
// Exports
module.exports = exports;
